import classNames from 'classnames';
import React, { FC } from 'react';

interface Props {
  title: string;
  description: string;
  className?: string;
}

export const WizardContentSectionTemplate: FC<Props> = ({
  title,
  description,
  children,
  className = 'border-b-bedrock-gray-medium',
}) => (
  <div className={classNames('flex flex-col gap-4 text-bedrock-black py-6 border-b', className)}>
    <div className='flex flex-col gap-1'>
      <span className='text-bedrock-p-strong'>{title}</span>
      <span className='text-bedrock-p-small'>{description}</span>
    </div>
    <div>{children}</div>
  </div>
);
